import { render, staticRenderFns } from "./CandidateList.vue?vue&type=template&id=6e1367b1&"
import script from "./CandidateList.vue?vue&type=script&lang=ts&"
export * from "./CandidateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports